module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1508-a25d671760a99344f6e01dc39cfe225a.png";